import { connect } from 'react-redux';
import { updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_EDUCATION_GOAL_API, BACKEND_EDUCATION_LIST_KEY } from '../ChildrenInfoWorkflowConstants';
import * as childrenSelector from '../ChildrenInfoWorkflowSelector';
import TuitionTypeView from './TuitionTypeView';

const mapStateToProps = (state, ownProps) => {
  const clientId = childrenSelector.clientId(state, ownProps);
  const childFirstName = childrenSelector.getSelectedChildFirstName(state, ownProps);
  const goalsList = childrenSelector.getEducationGoalList(state, ownProps);
  const childEducationGoal = childrenSelector.getChildEducationGoal(goalsList, childFirstName);
  const isEditingGoal = !!childEducationGoal.Id;

  const updatedEducationGoalData = childrenSelector.getUpdatedEducationGoalData(state, ownProps);

  const educationGoal = {
    ...childEducationGoal,
    ...updatedEducationGoalData,
    ClientId: clientId,
  };

  return { clientId, isEditingGoal, educationGoal };
};

const mapDispatchToProps = dispatch => ({
  store: (isInState, amount, workflowId, clientId) => {
    dispatch(updateSupportData({
      [BACKEND_EDUCATION_LIST_KEY]: {
        SpecificCollegeIsInState: isInState,
        Amount: amount,
      },
    }, workflowId, clientId));
  },
  onPostProcess: (data, educationGoal) => ({ [BACKEND_EDUCATION_GOAL_API]: educationGoal }),
});

export default connect(mapStateToProps, mapDispatchToProps)(TuitionTypeView);
